import React from "react";
import { PrinterIcon } from "@heroicons/react/24/outline";
import BookingPrintTemplate from "./BookingPrintTemplate";

function BookingsTable({ bookings, hospital }) {
  const handlePrint = (booking) => {
    const printFunction = BookingPrintTemplate({ booking, hospital });
    printFunction();
  };

  return (
    <div className="overflow-x-auto bg-white shadow-md rounded-lg border border-gray-300 p-6">
      <table className="min-w-full table-auto">
        <thead>
          <tr className="bg-gray-200">
            <th className="py-3 px-4 text-left text-sm font-semibold text-gray-700">
              #
            </th>
            <th className="py-3 px-4 text-left text-sm font-semibold text-gray-700">
              Doctor
            </th>
            <th className="py-3 px-4 text-left text-sm font-semibold text-gray-700">
              Department
            </th>
            <th className="py-3 px-4 text-left text-sm font-semibold text-gray-700">
              Patient Name
            </th>
            <th className="py-3 px-4 text-left text-sm font-semibold text-gray-700">
              Phone Number
            </th>
            <th className="py-3 px-4 text-left text-sm font-semibold text-gray-700">
              Booking Date
            </th>
            <th className="py-3 px-4 text-left text-sm font-semibold text-gray-700">
              Time Slot
            </th>
            <th className="py-3 px-4 text-left text-sm font-semibold text-gray-700">
              Status
            </th>
            <th className="py-3 px-4 text-left text-sm font-semibold text-gray-700">
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {bookings && bookings.length > 0 ? (
            bookings.map((booking, index) => (
              <tr
                key={booking.bookingId || index}
                className={`${
                  index % 2 === 0 ? "bg-gray-50" : "bg-white"
                } border-t hover:bg-blue-50 transition duration-150`}
              >
                <td className="py-3 px-4 text-sm text-gray-800 font-medium">
                  {index + 1}
                </td>
                <td className="py-3 px-4 text-sm text-gray-800">
                  {booking.doctorName || "N/A"}
                </td>
                <td className="py-3 px-4 text-sm text-gray-800">
                  {booking.departmentName || "N/A"}
                </td>
                <td className="py-3 px-4 text-sm text-gray-800">
                  {booking.patientName || "N/A"}
                </td>
                <td className="py-3 px-4 text-sm text-gray-800">
                  {booking.patientPhoneNumber || "N/A"}
                </td>
                <td className="py-3 px-4 text-sm text-gray-800">
                  {new Date(booking.bookingDate).toLocaleDateString()}
                </td>
                <td className="py-3 px-4 text-sm text-gray-800">
                  {booking.timeSlot}
                </td>
                <td className="py-3 px-4 text-sm">
                  <span
                    className={`px-2 py-1 rounded-full text-xs font-semibold capitalize ${
                      booking.status === "booked"
                        ? "bg-green-100 text-green-800"
                        : booking.status === "confirmed"
                        ? "bg-blue-100 text-blue-800"
                        : booking.status === "completed"
                        ? "bg-gray-100 text-gray-800"
                        : booking.status === "cancelled"
                        ? "bg-red-100 text-red-800"
                        : "bg-yellow-100 text-yellow-800"
                    }`}
                  >
                    {booking.status}
                  </span>
                </td>
                <td className="py-3 px-4 text-sm">
                  <button
                    onClick={() => handlePrint(booking)}
                    className="p-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors shadow-sm hover:shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1"
                    title="Print Booking"
                  >
                    <PrinterIcon className="w-5 h-5" />
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan="9"
                className="py-4 px-4 text-center text-sm text-gray-600 italic"
              >
                No bookings available.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default BookingsTable;
